module.exports = __webpack_public_path__ + "static/media/insta10.6e6e2043.jpg";